import { Suspense, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { DashboardCustomizer, useDashboardPreferences, WIDGET_REGISTRY } from "@/components/Dashboard";

const WidgetFallback = () => (
	<div className="rounded-xl border border-muted p-6">
		<Skeleton className="h-6 w-40 mb-4" />
		<Skeleton className="h-24 w-full rounded-lg" />
	</div>
);

export const Home = () => {
	const { isWidgetEnabled, setWidgetEnabled } = useDashboardPreferences();
	const [customizerOpen, setCustomizerOpen] = useState(false);

	const visibleWidgets = WIDGET_REGISTRY.filter(w => isWidgetEnabled(w.id)).sort(
		(a, b) => a.defaultOrder - b.defaultOrder,
	);

	return (
		<div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6 h-full overflow-auto">
			<header className="flex items-center justify-between">
				<h1 className="text-2xl md:text-4xl font-semibold tracking-tight">Home</h1>
				<Button variant="outline" size="sm" onClick={() => setCustomizerOpen(true)} className="gap-1.5">
					<Settings2 className="h-3.5 w-3.5" />
					Customize
				</Button>
			</header>

			<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
				<AnimatePresence mode="popLayout">
					{visibleWidgets.map((widget, i) => {
						const Component = widget.component;
						return (
							<motion.div
								key={widget.id}
								layout
								initial={{ opacity: 0, y: 20, scale: 0.97 }}
								animate={{ opacity: 1, y: 0, scale: 1 }}
								exit={{ opacity: 0, scale: 0.95 }}
								transition={{
									delay: i * 0.06,
									duration: 0.4,
									ease: [0.25, 0.46, 0.45, 0.94],
								}}
								className={widget.colSpan === 2 ? "lg:col-span-2" : ""}
							>
								<Suspense fallback={<WidgetFallback />}>
									<Component />
								</Suspense>
							</motion.div>
						);
					})}
				</AnimatePresence>
			</div>

			<DashboardCustomizer
				open={customizerOpen}
				onOpenChange={setCustomizerOpen}
				isWidgetEnabled={isWidgetEnabled}
				setWidgetEnabled={setWidgetEnabled}
			/>
		</div>
	);
};
